export const gradingsContainer = {
  margin: 'auto',
  padding: '32px',
  background: '#fff',
  marginTop: '40px',
  border: '1px solid rgb(236, 236, 236)',
}

export const button = {
  width: 200,
  boxShadow: "none",
  height: 40,
}
